module.exports = __webpack_public_path__ + "static/media/In_Stock.69b0a213.svg";